<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/business/add_card')"
      >添加</el-button
    >
    <el-button
      type="danger"
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-input
      style="float: right"
      class="screenInput"
      v-model="screen.link_name"
      placeholder="请输入联系人名称"
    >
    </el-input>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择项目"
      :disabled="userInfo.park_id != 0"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="项目" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="名片联系人" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.link_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="职位">
        <template slot-scope="scope">
          <span>{{ scope.row.position }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地点" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/business/edit_card')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="info"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/business/edit_card')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/business/card_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择项目" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            class="w4"
            placeholder="请选择项目"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名片联系人" prop="link_name">
          <el-input
            class="w4"
            v-model="ruleForm.link_name"
            placeholder="请输入名片联系人"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input
            class="w4"
            v-model="ruleForm.position"
            placeholder="请输入职位"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input
          maxlength="11"
            class="w4"
            type="tel"
            v-model="ruleForm.tel"
            placeholder="请输入联系电话"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            class="w4"
            type="email"
            v-model="ruleForm.email"
            placeholder="请输入邮箱"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input
            class="w4"
            type="text"
            v-model="ruleForm.wechat"
            placeholder="请输入微信号"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="thumbs">
          <el-upload
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <!-- <img
              v-if="ruleForm.thumb"
              :src="imageUrl + ruleForm.thumb"
              class="avatar-uploaders"
            /> -->
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="视频" prop="video">
          <el-upload
            name="file[]"
            :action="ossUpload"
            :headers="{ token: token }"
            :data="{ type: 'video' }"
            accept="video/mp4"
            list-type="picture-card"
            :show-file-list="false"
            :on-error="videoErr"
            :on-progress="videoProgross"
            :on-success="handleVideoSuccess"
            :disabled="cztype == 'see'"
          >
            <el-progress
              v-if="percentage != 0 && percentageShow"
              type="circle"
              :percentage="percentage"
            ></el-progress>
            <div class="video-box" v-if="ruleForm.video">
              <div class="handles">
                <i
                  class="el-icon-delete"
                  @click.stop="delVideo"
                  v-if="cztype != 'see'"
                ></i>
              </div>
              <video controls :src="imageOss + ruleForm.video" />
            </div>
            <i class="el-icon-plus avatar-uploader-icon" v-else></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            type="textarea"
            :rows="2"
            class="w4"
            v-model="ruleForm.address"
            placeholder="请输入地址"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            :disabled="cztype == 'see'"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, delImage } from "@/api/index";
import {
  add_card,
  edit_card,
  card_lists,
  card_del,
  card_info,
} from "@/api/investment";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        link_name: "",
      },
      typeList: [],
      total: 0,
      ruleForm: {},
      fileList: [],
      rules: {
        park_id: [{ required: true, message: "请选择项目", trigger: "change" }],
        thumbs: [{ required: true, message: "请选择图片" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        link_name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
        video: [{ required: true, message: "请选择视频", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      clearVideos: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    delVideo() {
      this.clearVideos.push(this.ruleForm.video);
      this.ruleForm.video = "";
    },
    videoProgross(e) {
      this.percentage = parseInt(e.percent);
    },
    handleVideoSuccess(res, file, fileList) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumbs = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearVideos.length) {
        delImage({ file: this.clearVideos.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumbs = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    reset() {
      this.screen = {
        park_id: "",
        link_name: "",
        page: 1,
        page_size: 15,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              edit_card(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      card_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          thumbs: res.data.info.thumbs,
          video: res.data.info.video,
          sort: res.data.info.sort,
          link_name: res.data.info.link_name,
          address: res.data.info.address,
          email: res.data.info.email,
          wechat: res.data.info.wechat,
          position: res.data.info.position,
          tel: res.data.info.tel ? Number(res.data.info.tel) : null,
        };
        var list = res.data.info.thumbs.split(",");
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          card_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              add_card(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        thumbs: "",
        sort: 0,
        link_name: "",
        position: "",
        address: "",
        email: "",
        wechat: "",
        tel: "",
        video: "",
      };
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取项目
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      card_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
